import type React from 'react';

const SILENT_MONITORING_COMPOSITES: Record<string, { label: string; short: string; tone: string }> =
  {
    'shadow+visible-to-attendant': {
      label: 'Visível ao atendente',
      short: 'Shadow · visível',
      tone: 'neutral',
    },
    'supervisor+invisible-to-all': {
      label: 'Invisível',
      short: 'Supervisor · invisível',
      tone: 'inverted',
    },
    'collaborator+visible-to-both': {
      label: 'Público',
      short: 'Colaborador · público',
      tone: 'brand',
    },
  };

const iconMap: Record<string, string> = {
  'shadow+visible-to-attendant': '👁',
  'supervisor+invisible-to-all': '👁‍🗨',
  'collaborator+visible-to-both': '📢',
};

export interface CoAttendanceModeIndicatorProps {
  composite?: string;
  role?: string;
  visibilityMode?: string;
}

export function CoAttendanceModeIndicator({
  composite,
  role,
  visibilityMode,
}: CoAttendanceModeIndicatorProps): React.JSX.Element | null {
  let key: string | undefined = composite;
  if (key === undefined || key === '') {
    if (
      role !== undefined &&
      role !== '' &&
      visibilityMode !== undefined &&
      visibilityMode !== ''
    ) {
      key = `${role}+${visibilityMode}`;
    }
  }
  if (key === undefined || key === '') return null;
  const m = SILENT_MONITORING_COMPOSITES[key];
  if (m === undefined) return null;
  return (
    <span className={`coatt-badge coatt-badge--${m.tone}`} data-composite={key}>
      <span className="coatt-badge__icon" aria-hidden="true">
        {iconMap[key] ?? '·'}
      </span>
      <span className="coatt-badge__label">Modo: {m.label}</span>
      <span className="coatt-badge__role mono">({key})</span>
    </span>
  );
}
